module.exports = "/images/bd.svg?c973dab2bddf4e30eb11c9c001ba86a1";